<div>
    

    <div >
        <div class="Tabletitle">Bulk Update Metadata Details
        </div>
    </div>    
    <div>        
        <mat-form-field class="element-filter" *ngIf="docsList">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)">
        </mat-form-field>
    </div>

    <div *ngIf="noDocuments" class="docmessage card">
        <div class="card-body">
            No export files to display.
        </div>
    </div>

    <div class="container-fluid" *ngIf="!noDocuments">
        
        <div style="margin-top: 1em; margin-bottom: 1em; text-align-last: end">
            <div>
                (Total Count: {{docLength}})
            </div>
        </div> 
        <div class="mat-elevation-z2">
            <button
        mat-stroked-button
        class="btn btn-small"
        title="refresh"
        (click)="refresh()"
        style="vertical-align: middle;"
      >
        <mat-icon title="refresh">refresh</mat-icon>
        </button>
        <table mat-table [dataSource]="docsList" matSort>

            <ng-container matColumnDef="srNum">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element;let i=index">
                    {{ (i+1) + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
            </ng-container>
            <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested By </th>
                <td mat-cell *matCellDef="let element"> {{element.created_by}} </td>
            </ng-container>
            <ng-container matColumnDef="create_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested Date </th> 
                <td mat-cell *matCellDef="let element"> {{element.create_date | date:'medium'}} </td> 
            </ng-container>
            <ng-container matColumnDef="search_query">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Search Query </th>
                <td mat-cell *matCellDef="let element"> {{element.search_query | json}} </td>
            </ng-container>
            <ng-container matColumnDef="update_values">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Update Values</th>
                <td mat-cell *matCellDef="let element"> {{element.update_values | json}} </td>
            </ng-container>
            <ng-container matColumnDef="document_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Document Count </th>
                <td mat-cell *matCellDef="let element"> {{element.document_count}} </td>
            </ng-container>
            <ng-container matColumnDef="completed_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Completed Date </th>
                <td mat-cell *matCellDef="let element"> {{element.completed_date | date:'medium'}} </td>
            </ng-container>
            <ng-container matColumnDef="operation_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.operation_status}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
            <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row" [class.selected-row]="selectedRow === row" (click)="selectedRow = selectedRow === row ? null : row">
            </tr>
            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

        </table>
        <mat-paginator #myPaginator [pageSizeOptions]="[50, 100]" [pageSize]="50" showFirstLastButtons>
        </mat-paginator>
    </div>
    </div>
